<template>
    <div class="az-form-content">
        <ModalResponderEsclarecimentoImpugnacao
                v-if="modalResposta"
                v-model="modalResposta"
                @fecharModal="fecharModalEsclarecimento"
                :item="esclarecimentoSelecionado"
        />
        <ModalVisualizarRespostaEsclarecimentoImpugnacao
                v-if="modalVisualizacao"
                v-model="modalVisualizacao"
                @fecharModalVisualizacao="fecharModalVisualizacao"
                :item="esclarecimentoSelecionado"
        />
        <ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao
                v-if="modalConvidarUsuario"
                v-model="modalConvidarUsuario"
                :esclarecimento-impugnacao-id="esclarecimentoSelecionado ? esclarecimentoSelecionado.id : null"
                @convite-enviado="buscarEsclarecimentos"
        />
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Esclarecimentos</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="esclarecimentos.length > 0"
                                  :headers="colunas"
                                  :items="esclarecimentos"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                    </span>
                                    <span v-else-if="props.item.nomeRazaoSocial">
                                      {{ props.item.nomeRazaoSocial }}
                                    </span>
                                    <span v-else>--</span>
                                </td>
                                <td class="d-inline-block text-truncate max-25">{{ props.item.assunto }}</td>
                                <td>
                                    <span>{{ possuiAnexo(props.item) }}</span>
                                </td>
                                <td :class="{'status-rascunho' : props.item.situacao === 'RASCUNHO'}">{{ props.item.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao) }}</td>
                                <td class="table-actions">
                                    <div>
                                        <div>
                                            <a v-if="props.item.relatorioUri" :href="criarLinkDownload(props.item.relatorioUri)" target="_blank"
                                               title="Download Relatório" class="az-action-link-icon">
                                              <v-icon>get_app</v-icon>
                                            </a>
                                            <a title="Responder" v-if="props.item.situacao != 'RASCUNHO'" @click="abrirModalResposta(props.item)">
                                                <v-icon>reply</v-icon>
                                            </a>
                                            <a title="Convidar para Responder" v-if="exibirConvidarUsuario && props.item.situacao != 'RASCUNHO'" @click="abrirModalConvidarUsuario(props.item)">
                                                <v-icon>person_add</v-icon>
                                            </a>
                                            <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                                <v-icon>search</v-icon>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!esclarecimentos.length && !editando">
                    <az-ops title="Nenhum esclarecimento encontrado."
                            message="Este processo não possui nenhum esclarecimento até o momento."
                    ></az-ops>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import {actionTypes, tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
    import ModalResponderEsclarecimentoImpugnacao from './Modal/ModalResponderEsclarecimentoImpugnacao'
    import ModalVisualizarRespostaEsclarecimentoImpugnacao from './Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao'
    import ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao from './Modal/ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao'
    import {mapState, mapActions} from "vuex";

    export default {
        name: 'LicitacaoEsclarecimentoTabela',
        components: {ModalVisualizarRespostaEsclarecimentoImpugnacao, ModalResponderEsclarecimentoImpugnacao, ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao},
        inject: ['$validator'],
        props: ['editando', 'esclarecimentos'],
        data() {
            return {
                modalResposta: false,
                modalVisualizacao: false,
                modalConvidarUsuario: false,
                esclarecimentoSelecionado: null,
                licitacaoId: undefined,
                repository: 'repo1:licitacao',
                tiposSituacaoEsclarecimentoImpugnacao
            }
        },
        computed:{
            ...mapState(['licitacao', 'parametros']),
            colunas(){
                return this.criarColunas(6,
                    ['Data','Empresa','Assunto Esclarecimento','Anexo','Situação', 'Ações'],
                    [],
                    [false,false,false,false,false, false],
                    ['left','left','left','left','left','center'],
                    ['15%','15%','25%','10%','20%', '15%'],
                    'primary--text')
            },
            exibirConvidarUsuario(){
              return this.parametros.propriedadesLicitacao.habilitarConviteResponderEsclarecimentoImpugnacao && this.licitacao.registroPreco === 'S'
            }
        },
        methods: {
            ...mapActions([
                actionTypes.BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO,
                actionTypes.CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO
            ]),
            possuiAnexo(item){
                if(item.arquivoUri){
                    return 'Sim'
                }else{
                    return 'Não'
                }
            },
            abrirModalVisualizacao(item){
                this.modalVisualizacao = true
                this.esclarecimentoSelecionado = item
            },
            abrirModalResposta(item){
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                  return
                }
                if(!this.licitacao.esclarecimentoImpugnacao){
                  this.mostrarNotificacaoErro("Não é possível responder, habilite a funcionalidade de esclarecimento e impugnação!")
                  return
                }
                this.modalResposta = true
                this.esclarecimentoSelecionado = item
            },
            fecharModalEsclarecimento(){
                this.modalResposta = false
                this.esclarecimentoSelecionado = null
                this.$emit('buscarEsclarecimentos')
            },
            fecharModalVisualizacao(){
                this.modalVisualizacao = false
                this.esclarecimentoSelecionado = null
            },
            abrirModalConvidarUsuario(item){
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                  return
                }
                if(!this.licitacao.esclarecimentoImpugnacao){
                  this.mostrarNotificacaoErro("Não é possível convidar, habilite a funcionalidade de esclarecimento e impugnação!")
                  return
                }
                this.modalConvidarUsuario = true
                this.esclarecimentoSelecionado = item
            },
            buscarEsclarecimentos(){
                this.$emit('buscarEsclarecimentos')
            }
        }
    }
</script>

<style scoped>
.table-status__error i {
    font-size: 18px;
    color: #d79641;
}

.table-dados-esclarecimentos td {
    color: #777;
}

.status-rascunho{
  color: #F54927 !important;
}

@media (max-width: 720px) {
    .table-dados-esclarecimentos td:nth-of-type(1):before {
        display: none;
    }

    .table-dados-esclarecimentos td:nth-of-type(2):before {
        content: "Tipo:";
    }

    .table-dados-esclarecimentos td:nth-of-type(3):before {
        content: "Data:";
    }

    .table-dados-esclarecimentos td:nth-of-type(4):before {
        content: "Nome:";
    }

    .table-dados-esclarecimentos td:nth-of-type(5):before {
        display: none;
    }
}
</style>
